<ng-container *transloco="let t">
  <main class="dominio-no-asignado" data-testid="suite-tenant-unassigned-domain">
    <section class="dominio-no-asignado__caja" role="alert">
      <h1
        class="dominio-no-asignado__titulo"
        data-testid="suite-tenant-unassigned-domain-title"
      >{{ t('tenant.unassignedDomain.title') }}</h1>

      <p
        class="dominio-no-asignado__cuerpo"
        data-testid="suite-tenant-unassigned-domain-body"
      >{{ t('tenant.unassignedDomain.body') }}</p>

      <p
        class="dominio-no-asignado__pista"
        data-testid="suite-tenant-unassigned-domain-hint"
      >{{ t('tenant.unassignedDomain.hint') }}</p>
    </section>
  </main>
</ng-container>
